import { Component, OnInit, Input, ElementRef, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { SharedService } from './shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { MatDialog } from '@angular/material';
import { CashOnlyDialog } from './dashboard/dashboard/dashboard.component';
// import * as AWS from 'aws-sdk/global';
// import * as S3 from 'aws-sdk/clients/s3';
import { ElasticSearch, WebChatVariables, GlobalVariable } from './shared/global';
import { PlatformLocation } from '@angular/common';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { MapOfHeader } from './shared/models/shared-models';
import {DataDogRumService} from './datadog/DataDogRumService';

declare var TextDecoder;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    encapsulation: ViewEncapsulation.None,
    // tslint:disable-next-line:use-host-property-decorator
    host: {
        '(document:click)': 'onClick($event)',
    }
})
export class AppComponent {
    @ViewChild("botWindow") botWindowElement: ElementRef;
    // public property
    public is_spanish_lang: boolean;
    public is_english_lang: boolean;
    public msite_base_url: string;
    public show_chat: boolean;
    public enableClickOutside: boolean;
    public reward_token: string;
    private user_id: string;
    private convo_id: string;
    private token: string;
    private store: any;
    public isCashOnly: boolean;
    public reward_url: string = GlobalVariable.rewardsUrl + "login/login_by_stream/";
    private locale: string = "en-US";
	public signOutText = 'Sign Out';
	public app_header_title: MapOfHeader = {
        id: '',
        is_header_title: false,
        is_header_title_1: false,
        is_header_title_2: false,
        is_header_remove: false,
        header_class: '',
        header_title: '',
        header_tagline: '',
		notification_class: 'notification error',
        error_message: '',
        is_show_error: false,
        success_message: '',
        is_show_success_msg: false,
        is_logged_in: false,
        is_loader: false,
        cancel_url: '',
        is_cancel_visible: false,
        is_footer_remove: false,
        user: undefined,
        component_name: ''
    };

    currentYear: number = new Date().getFullYear();

    constructor(private sharedService: SharedService, private datadog: DataDogRumService, private router: Router, private localStorageService: LocalStorageService, @Inject(SESSION_STORAGE) private sessionStorageService: WebStorageService, private dialog: MatDialog, private platformLocation: PlatformLocation) {

		this.datadog.initialize();

        this.sharedService.cashOnlyUser.subscribe((cashOnly: boolean) => {
            this.isCashOnly = cashOnly;
        });
        this.sharedService.reward_token.subscribe((token: string) => {
            this.reward_token = token;
        });
        this.is_spanish_lang = true;
        this.is_english_lang = true;
        this.msite_base_url = 'https://www.pogoenergy.com/';
        this.localStorageService.set('msite_base_url', this.msite_base_url);
        const this_of_obj = this;
        setTimeout(function () {
            if (document.getElementById('which_language').innerHTML === 'English') {
                this_of_obj.msite_base_url = 'https://www.pogoenergy.com/';
                this_of_obj.localStorageService.set('msite_base_url', this_of_obj.msite_base_url);
            } else if (document.getElementById('which_language').innerHTML === 'Spanish' ||
                document.getElementById('which_language').innerHTML === 'Español') {
                this_of_obj.msite_base_url = 'https://es.pogoenergy.com/';
                this_of_obj.localStorageService.set('msite_base_url', this_of_obj.msite_base_url);
            }
        }, 6000);

      this.sharedService.listenLanguageCookieChange(({oldValue, newValue}) => {
        this.signOutText = this.sharedService.getSignOutTranslation();
      }, 1000);

        this.getUserInfo();
    }

	ngOnInit() {

		this.sharedService.get_elastic_search_url()
			.then((res) => {
				if (res && res['status'] == 'success' && res['result']) {
					ElasticSearch.url = res['result'][0]['esUrl'];
				}
			});

		this.sharedService.header_title.subscribe((header_title: MapOfHeader) => {
			if (header_title != null) {
				this.app_header_title = header_title;
			} // dynamically set headers
		});

		let currentLang = document.documentElement.lang;

		setInterval(() => {
			const newLang = document.documentElement.lang;
			if (newLang !== currentLang) {
				console.log(`Language changed to: ${newLang}`);
				currentLang = newLang;
				if (window.w1 && typeof window.w1 === 'function') {
					if (!document.getElementById('chat-root')) {
						console.error('Target element #chat-root not found');
					} else {
						console.log('setting language ', (currentLang === 'auto' || currentLang === 'en') ? "en" : "es")
						window.w1('setLanguageOverride', (currentLang === 'auto' || currentLang === 'en') ? "en" : "es");
						//window.w1('resetLanguageOverride');
					}
				}
			}
		}, 500);
	}

  getUserInfo() {
    this.user_id = this.sessionStorageService.get('UserID');
    if (this.user_id) {
    } else {
      this.sessionStorageService.set('UserID', this.user_id);
      WebChatVariables.user.user_name = "Pogo Customer";
    }
  }

    showChat(show: boolean) {
        this.show_chat = show;
        if (this.show_chat) {
            this.sharedService.chatbot();
        } else {
            const eventSendActivity = new Event('sendLeaveEvent');
            window.dispatchEvent(eventSendActivity);
        }
    }

    navigateToMakePayment() {
        if (this.isCashOnly) {
            this.dialog.open(CashOnlyDialog);
        } else {
            this.router.navigate(['./make-payment']);
        }
    }

    signOut() {
        let token;
        let type;
        if (this.localStorageService.get('token') !== null) {
            token = this.localStorageService.get('token');
            type = 'customer';
        } else if (this.localStorageService.get('agentToken') !== null) {
            token = this.localStorageService.get('agentToken');
            type = 'agent';
        }
        this.sharedService.signOut({ 'token': token })
            .then(response => {
                if (response.status === 'success') {
                    this.sharedService.setHeaderUserLoggedIn('sign_in', false, null);
                    if (type === 'customer') {
						this.localStorageService.remove('name');
						this.localStorageService.remove('billingAccountNumber');
                        this.localStorageService.remove('token');
                        this.localStorageService.remove('tempToken');
                        this.localStorageService.remove('last_skip_date');
                        if (this.localStorageService.get('agentToken') !== null) {
                            this.router.navigate(['./internal-user/dashboard']);
                        } else {
                            this.router.navigate(['./sign-in']);
                        }
                    } else if (type === 'agent') {
                        this.localStorageService.remove('agentToken');
                        this.router.navigate(['./internal-user/sign-in']);
                    }

					if (window.w1 && typeof window.w1 === 'function') {
						if (!document.getElementById('chat-root')) {
							console.error('Target element #chat-root not found');
							return;
						}
						window.w1('resetwidgetcontext');
					}
                }
            });
    }

    signOutAgent() {
        this.sharedService.signOut({ 'token': this.localStorageService.get('token') })
            .then(response => {
                if (response.status === 'success') {
                    this.localStorageService.remove('token');
                    this.localStorageService.remove('tempToken');
                    this.router.navigate(['./internal-user/sign-in']);
                }
            });
    }

	traslateLanguage(language: string) {
		if (language === 'english') {
			this.msite_base_url = 'https://www.pogoenergy.com/';
			this.localStorageService.set('msite_base_url', this.msite_base_url);
			WebChatVariables.locale = "en-US";
		}
		else
			if (language === 'spanish') {
				this.msite_base_url = 'https://es.pogoenergy.com/';
				this.localStorageService.set('msite_base_url', this.msite_base_url);
				WebChatVariables.locale = "es-mx";
			}

		if (this.show_chat) {
			this.sharedService.chatbot();
		}
		document.getElementById(language).click();
    }

    cancelRoute(route: string) {
        if (route != undefined && route.trim() != "") {
            this.router.navigate(['.' + route]);
        } else {
            this.platformLocation.back();
        }
    }

    onActivate(event) {
        // let scrollToTop = window.setInterval(() => {
        //   let pos = window.pageYOffset;
        //   if (pos > 0) {
        //     window.scrollTo(0, pos - 20); // how far to scroll on each step
        //   } else {
        //     window.clearInterval(scrollToTop);
        //   }
        // }, 16);
        this.sharedService.scrollToTopSmoothly();
    }

    chat() {
        const class_chat = document.getElementById('lc_chat_layout');
        if (class_chat.classList.contains('lc-collapsed')) {
            const len = document.getElementById('lc_chat_header');
            len.click();
        }
    }

    // tslint:disable-next-line:member-ordering
    @ViewChild('sidenav') sidenav: any;
    onClick() {
        if (this.sidenav !== undefined && this.sidenav.opened) {
            document.getElementsByClassName('sidenav-container')[0].className += ' sidenav-height';
        } else {
            document.getElementsByClassName('sidenav-container')[0].classList.remove('sidenav-height');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts